import React, { useEffect, useRef } from "react";

export const CinematicCursor = () => {
    const dotRef = useRef(null);
    const haloRef = useRef(null);
    const mouse = useRef({ x: -100, y: -100 });
    const halo = useRef({ x: -100, y: -100 });
    const raf = useRef(null);

    useEffect(() => {
        // Skip on coarse pointer / touch devices
        const isFine = window.matchMedia("(pointer: fine)").matches;
        if (!isFine) return;

        document.documentElement.classList.add("cinematic-cursor-on");

        const onMove = (e) => {
            mouse.current.x = e.clientX;
            mouse.current.y = e.clientY;
            if (dotRef.current) {
                dotRef.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate(-50%, -50%)`;
            }
        };

        const tick = () => {
            // Lerp halo for soft lag
            halo.current.x += (mouse.current.x - halo.current.x) * 0.14;
            halo.current.y += (mouse.current.y - halo.current.y) * 0.14;
            if (haloRef.current) {
                haloRef.current.style.transform = `translate3d(${halo.current.x}px, ${halo.current.y}px, 0) translate(-50%, -50%)`;
            }
            raf.current = requestAnimationFrame(tick);
        };

        const onOver = (e) => {
            const el = e.target.closest(
                'a, button, [role="button"], input, textarea, [data-cursor="hover"], .cine-card'
            );
            if (el) {
                dotRef.current?.classList.add("is-hover");
                haloRef.current?.classList.add("is-hover");
            }
        };
        const onOut = (e) => {
            const el = e.target.closest(
                'a, button, [role="button"], input, textarea, [data-cursor="hover"], .cine-card'
            );
            if (el) {
                dotRef.current?.classList.remove("is-hover");
                haloRef.current?.classList.remove("is-hover");
            }
        };

        const onLeave = () => {
            if (dotRef.current) dotRef.current.style.opacity = "0";
            if (haloRef.current) haloRef.current.style.opacity = "0";
        };
        const onEnter = () => {
            if (dotRef.current) dotRef.current.style.opacity = "1";
            if (haloRef.current) haloRef.current.style.opacity = "1";
        };

        window.addEventListener("mousemove", onMove);
        document.addEventListener("mouseover", onOver);
        document.addEventListener("mouseout", onOut);
        document.addEventListener("mouseleave", onLeave);
        document.addEventListener("mouseenter", onEnter);
        raf.current = requestAnimationFrame(tick);

        return () => {
            document.documentElement.classList.remove("cinematic-cursor-on");
            window.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseover", onOver);
            document.removeEventListener("mouseout", onOut);
            document.removeEventListener("mouseleave", onLeave);
            document.removeEventListener("mouseenter", onEnter);
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, []);

    return (
        <>
            <div ref={haloRef} className="cine-cursor-halo" data-testid="cinematic-cursor" aria-hidden="true" />
            <div ref={dotRef} className="cine-cursor-dot" aria-hidden="true" />
        </>
    );
};
